import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dException from "../Effect.Exception/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Utils$dDOM from "../Utils.DOM/index.js";
import * as Web$dDOM$dElement from "../Web.DOM.Element/index.js";
const show = /* #__PURE__ */ (() => Data$dList$dTypes.showNonEmptyList(Foreign.showForeignError).show)();
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Effect.applicativeEffect)(Data$dFoldable.foldableEither);
const Cmd = x => x;
const semigroupCmd = {
  append: v => v1 => dispatch => {
    const $0 = v(dispatch);
    return () => {
      $0();
      return v1(dispatch)();
    };
  }
};
const safeState = dictDecode => v => {
  const v1 = dictDecode.decode(v);
  if (v1.tag === "Left") { return Effect$dException.throwException(Effect$dException.error(show(v1._1)))(); }
  if (v1.tag === "Right") { return v1._1; }
  $runtime.fail();
};
const safeUpdate = dictDecode => update$p => x => update$p(safeState(dictDecode)(x));
const safeView = dictDecode => view$p => el => {
  const $0 = view$p(el);
  return x => $0(safeState(dictDecode)(x));
};
const safeInit = dictDecode => init$p => x => init$p(safeState(dictDecode)(x));
const onInitOrUpdate = element => initializer => updater => {
  const $0 = Utils$dDOM.getData("init-value")(element);
  return () => {
    const initValueForeign = $0();
    if (Foreign.isUndefined(initValueForeign)) {
      const value = initializer();
      return Utils$dDOM.setData("init-value")(value)(element)();
    }
    return updater(initValueForeign)();
  };
};
const onInit = element => initializer => {
  const $0 = Web$dDOM$dElement.getAttribute("data-initialized")(element);
  return () => {
    const initialized = $0();
    const $1 = (() => {
      if (initialized.tag === "Nothing") { return false; }
      if (initialized.tag === "Just") { return initialized._1 === "true"; }
      return false;
    })();
    if (!$1) {
      initializer();
      return Web$dDOM$dElement.setAttribute("data-initialized")("true")(element)();
    }
    if ($1) { return; }
    $runtime.fail();
  };
};
const onChange = dictDecode => input => dispatch => action => {
  const $0 = Utils$dDOM.getValue(input);
  return () => {
    const v = $0();
    return for_(dictDecode.decode(v))(val => dispatch(action(val)))();
  };
};
const newtypeCmd = {Coercible0: () => {}};
const monoidCmd = {mempty: dispatch => () => {}, Semigroup0: () => semigroupCmd};
const mapDispatch = tag => dispatch => x => dispatch(tag(x));
const functorCmd = {map: f => v => h => v(x => h(f(x)))};
const mapCmd = f => v => Data$dTuple.$Tuple(v._1, h => v._2(x => h(f(x))));
const effect = dictMonadTell => eff => dictMonadTell.tell(dispatch => eff);
const command = dictMonadTell => dictMonadTell.tell;
export {
  Cmd,
  command,
  effect,
  for_,
  functorCmd,
  mapCmd,
  mapDispatch,
  monoidCmd,
  newtypeCmd,
  onChange,
  onInit,
  onInitOrUpdate,
  safeInit,
  safeState,
  safeUpdate,
  safeView,
  semigroupCmd,
  show
};
